import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Details from "../../components/DetailsComponent";
import EventWImage from "../../components/EventWImageComponent";
import { Helmet } from "react-helmet-async";

export default function Neurodiversity() {
  
  const tulbNeuro = [
    "Tulburarea de spectru autist;",
    "ADHD;",
    "Tulburari specifice de invatare (dislexie, dispraxie si discalculie);",
    "Sindromul Tourette;",
    "Epilepsie;",
    "Tulburari de sanatate mintala (de exemplu, anxietate, depresie, TOC, tulburare bipolara, schizofrenie, tulburari de alimentatie);",
    "Afectiuni de dezvoltare (de exemplu, tulburare de dezvoltare a limbajului). Sursa: National Autistic Society, https://www.autism.org.uk/.../autism-and-neurodiversity);",
  ];
  return (
    <>
        <Helmet>
        <title>Neurodiversitatea</title>
        <meta
          name="description"
          content="Neurodivergenta presupune ca modul in care informatiile sunt procesate de creier este diferit de ceea ce este considerat tipic. Persoanele neurodivergente experimenteaza si reactioneaza diferit fata de persoanele „neurotipice”."
        />
        <link rel="canonical" href="https://www.psinapsis.ro/articles/neurodiversityarticle" />
      </Helmet>

      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">
          <Title title="Neurodivergenta" />

          <Details
          normalText="Neurodiversitatea este un termen folosit pentru a sublinia realitatea biologica: creierele umane sunt diferite unele de celelalte." />

          <Details normalText="Sistemul nervos este cel care transporta informatii de la simturile noastre la creier (inclusiv cele cinci simturi principale precum si alte simturi precum proprioceptia, interoceptia, echilibrul, constientizare spatiala), si de la creier catre corp. Este modul in care observam si reactionam la lucrurile din mediul nostru si din interiorul corpului nostru." />

          <Details normalText="Deoarece oamenii sunt neurodiversi, experienta si reactiile sunt, in mod clar diferite, precizand insa ca unele grupuri de oameni pot experimenta diferente semnificative. Cand aceste diferente au legatura cu modul in care informatiile din simturi sunt procesate de creier, discutam despre neurodivergenta." />

          <Details normalText="Neurodiversitatea si neurodivergenta sunt doua concepte descrise pentru prima data la mijlocul anilor '90 de catre persoane diagnosticate cu autism, concepte care au aparut pe forumurile din mediul online." />

          <Details normalText="Conform National Autistic Society tulburarile care intra sub incidenta neurodivergentei sunt:" />         
          
          <EventWImage
            photoSource="/images/neurodiversity.jpg"
            alt="Interventia terapeutica in tulburarile de limbaj, Calinescu Diana, Asociatia PsiNapsis Sibiu"
            objectives={tulbNeuro}
          />
          <Details normalText="Sursa: National Autistic Society" />
                    <div className="mx-5 mb-3 fs-6 linkArt">
                      <a href="https://www.autism.org.uk/advice-and-guidance/topics/identity/autism-and-neurodiversity">
                        https://www.autism.org.uk/advice-and-guidance/topics/identity/autism-and-neurodiversity
                      </a>
                    </div>
          <Image
            className="photoArticol d-block d-md-none mx-auto "
            src="/images/neurodiversity.jpg"
            alt="Interventia terapeutica in tulburarile de limbaj, Calinescu Diana, Asociatia PsiNapsis Sibiu"
          />

          <Details normalText="Iata ca astfel, paradigma neurodivergentei aduce sub umbrela ei o serie de tulburari care ne ofera oportunitatea de a explica varii comportamente, manifestari, trairi ale copiilor si adultilor pe care ii intalnim, a le interconecta si a cauta cele mai bune directii pentru fiecare." />

          <Details normalText="Echilibrul pentru care militam in abordarea fiecarui copil, adult, a fiecarei familii poate sa presupuna un demers lung, variatii ale progresului, obstacole emotionale, piedici concrete, nevoie de suport informational, educational, social, limite individuale." />

          <Details normalText="Oamenii intalniti in cabinet nu pot fi niciodata redusi la o lista exhaustiva de simptome sau trasaturi din manualele de psihodiagnostic, fiecare persoana avand nevoie de grija, atentie, observatii pertinente, compasiune, respect si valorizare." />

          <Details normalText="Intr-o maniera sau alta, neurodiversitatea este cat se poate de reala, astfel este nevoie sa privim cu claritate si deschidere spre modul in care tolerarea diferentelor si integrarea neurodiversitatii reprezinta premise ale evolutiei spre o societate functionala, incluziva." />

          <Details normalText="Terapia de recuperarea nu duce la eliminarea/absenta unei tulburari de neurodezvoltare." />

          <Details normalText="Am ales, ca echipa, sa folosim termenul de terapie de recuperare pentru ca, prin interventia specializata pe care o implementam, ne dorim sa recuperam din deficitul existent in diverse arii precum comunicare si relationare sau autonomie personala. Recuperam din intarzierea existenta pentru a contura un set de achizitii care sa permita copilului/adultului neurodivergent sa fie auzit, sa fie inteles, sa ii fie indeplinite nevoile de baza, sa aiba sanse mai mari sa se simta integrat in comunitatea din care face parte." />
          
        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
